export const linearModel = {
  name: 'Longitudinal Monte Carlo',
  type:'method',
  description:
    'The calculations were based on a Longitudinal Monte Carlo simulation using copula-based dependencies fitted via Maximum Likelihood Estimation (MLE) with Gaussian, t-Student, Clayton, Gumbel, and Frank copulas. Copula-based correlations are computed as rho = 12 * double integral of C(u,v) du dv - 3, then applied to PCA to extract key risk factors. 1250 simulations are run to compute annualized returns for both the Actual and Simulated portfolios, which are then compared.',
};
